import { render } from "./ProfitLossChart.vue?vue&type=template&id=e2f93620&ts=true"
import script from "./ProfitLossChart.vue?vue&type=script&lang=ts"
export * from "./ProfitLossChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__